import {v4 as uuidV4} from 'uuid';
import SearchTracking, {SEARCH_TRACKING_ACTIONS} from 'utils/search-tracking';
import SegmentUtils from 'utils/segment';
import ErrorUtils from 'utils/error-utils';
import {getFacilitiesByPackage} from 'api/event-packages';
import {notify} from '../notification/notification-actions';
import {loadTravelDistancesV2} from './spots-actions-v2';

export const SPOTS_GET_EVENT_PACKAGE = 'SPOTS_GET_EVENT_PACKAGE';

export const loadSpotsEventPackage = ({eventPackageId}) => {
    return (dispatch, getState) => {
        const segmentId = SegmentUtils.getAnonymousId();

        SearchTracking.updateAction(SEARCH_TRACKING_ACTIONS.SEARCH);
        const {
            sessionUUID,
            searchUUID,
            actionUUID,
        } = SearchTracking.getValues();

        /* eslint-disable camelcase */
        return dispatch({
            type: SPOTS_GET_EVENT_PACKAGE,
            payload: getFacilitiesByPackage(eventPackageId, {
                session_id: sessionUUID,
                search_id: searchUUID,
                action_id: actionUUID,
                segment_id: segmentId,
                include: 'amenities_full',
            }).then(response => {
                return {
                    results: response,
                };
            }),
        }).catch(error => {
            SegmentUtils.track({
                event: 'Error Message Displayed',
                properties: {
                    'error message': 'Error fetching spots',
                    'error screen': 'search',
                    'error action': 'fetching spots',
                },
            });

            dispatch(
                notify({
                    id: uuidV4(),
                    type: 'error',
                    message: 'Error fetching spots',
                })
            );

            return ErrorUtils.formatError(error);
        });
        /* eslint-enable camelcase */
    };
};

export const loadEventPackageSpotAndTravelDistances = ({eventPackageId}) => {
    return (dispatch, getState) => {
        return dispatch(
            loadSpotsEventPackage({
                eventPackageId,
            })
        ).then(() => {
            const allSpots = getState().spots.data;
            const spotCoordinates = allSpots.slice(0, 10).map(spot => {
                const primaryAddress = spot.addresses[0];

                return {
                    spotId: spot.spotId,
                    latitude: primaryAddress.latitude,
                    longitude: primaryAddress.longitude,
                };
            });

            return dispatch(loadTravelDistancesV2(spotCoordinates));
        });
    };
};
